import Immutable from 'immutable';

const initialState = Immutable.Map();

function showStarted(state, _payload) {
  return state
    .set('loading', true)
    .set('completed', false)
    .set('failed', false)
    .set('errors', {});
}

function showCompleted(state, payload) {
  return state
    .set('loading', false)
    .set('completed', true)
    .set('failed', false)
    .set('record', payload)
    .set('errors', {});
}

function showFailed(state, payload) {
  return state
    .set('loading', false)
    .set('completed', false)
    .set('failed', true)
    .set('errors', payload.errors);
}

export default function reducer(state = initialState, { type, payload }) {
  return state.withMutations((mutableState) => {
    return (
      {
        USER_OVERVIEW_SHOW: showStarted,
        USER_OVERVIEW_SHOW_COMPLETED: showCompleted,
        USER_OVERVIEW_SHOW_FAILED: showFailed,
      }[type] || (() => mutableState)
    )(mutableState, payload);
  });
}
